import {createContext} from 'react';

import {ValueResolver, DocumentValue} from '@/engine';
import {DocumentStoreApi} from '../store/document-store';

export type DocumentUtilsContextType = {
  store: DocumentStoreApi;
  valueResolver: ValueResolver;
  serialize: (data: DocumentValue | DocumentValue[]) => string;
};

export const DocumentUtilsContext = createContext<DocumentUtilsContextType | null>(null);
